import { Controller, Control, RegisterOptions } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material';

interface SelectMenuProps {
  label: string;
  name: string;
  values: any[];
  valueAttr: string;
  labelAttr: string;
  disabledAttr?: string;
  control: Control<any>;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  errorMessage?: string;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  defaultValue?: any;
  className?: string;
  inputProps?: any;
  onChange?: (evt: any) => void;
}

const StyledArrowIcon = styled(KeyboardArrowDownIcon)(({ theme }) => ({
  color: `${theme.palette.lightActionDisabled54p.main} !important`,
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-readOnly': {
    background: `${theme.palette.lightBackgroundPaperHover.main} !important`,
  },
}));

export default function SelectMenu({
  label,
  name,
  control,
  values,
  valueAttr,
  labelAttr,
  disabledAttr,
  required = false,
  disabled = false,
  readOnly = false,
  errorMessage,
  rules = undefined,
  defaultValue = undefined,
  className = undefined,
  inputProps = undefined,
  onChange,
}: SelectMenuProps) {
  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      render={({ field, fieldState }) => (
        <FormControl className={className}>
          <StyledTextField
            {...field}
            select
            required={required}
            label={label}
            variant="outlined"
            disabled={disabled}
            helperText={errorMessage || fieldState?.error?.message}
            error={!!errorMessage || !!fieldState?.error}
            onChange={
              onChange
                ? (e) => {
                    field.onChange(e);
                    onChange(e);
                  }
                : field.onChange
            }
            inputProps={inputProps}
            InputProps={{
              readOnly,
            }}
            SelectProps={{
              IconComponent: StyledArrowIcon,
              sx: readOnly
                ? {
                    pointerEvents: 'none',
                    '& .MuiSelect-select': {
                      cursor: 'default',
                    },
                  }
                : !label
                  ? {
                      '& .MuiSelect-select': {
                        paddingTop: '2px',
                      },
                    }
                  : undefined,
            }}>
            {values.map((val, idx) => {
              return (
                <MenuItem
                  value={val[valueAttr]}
                  key={idx}
                  disabled={disabledAttr ? val[disabledAttr] : false}>
                  {val[labelAttr]}
                </MenuItem>
              );
            })}
          </StyledTextField>
        </FormControl>
      )}
    />
  );
}
